(function () {
    'use strict';

    angular
        .module('blocks.backendHubProxy')
        .factory('backendHubProxy', backendHubProxy);

    backendHubProxy.$inject = ['$rootScope', 'common', 'config', 'signalrEndPoint', '$timeout'];

    /* @ngInject */
    function backendHubProxy($rootScope, common, config, signalrEndPoint, $timeout) {
        var _connection;
        var _stopCalled = false;

        var service = {
            startListening: startListening,
            stop: stop,
            items: [],
            displayedItems: [],
            bookData: [],
            displayedBookData : [],
            topic: {}
        };

        return service;

        function stop() {
            if (_connection && _connection.state && _connection.state !== 4 /* disconnected */) {
                _stopCalled = true;
                _connection.stop();
            }
        }  

        function startListening() {
            _connection = $.hubConnection(signalrEndPoint);
            _connection.logging = false;
            var proxy = _connection.createHubProxy("sevenPointHub");
            var userData = JSON.parse(localStorage.getItem('7PointUserData'));
            if (userData && userData.bearerToken) {
                _connection.qs = { "Bearer": userData.bearerToken };
            }

            proxy.on("alertAdded", function (result) {
                _addAlert(result);
            });

            proxy.on("noteAdded", function (result) {
                _addNote(result);
            });
            
            proxy.on("taskAdded", function (result) {
                
                _addTask(result);
            });

            proxy.on("availableAtUpdated", function (result) {
                _availableAtUpdated(result);
            });
            
            
            proxy.on("taskNoteDeleted", function (id) {
                _deleteNote(id);
            });
            
            proxy.on("noteUpdate", function (result) {
                _updateNote(result);
            })

            proxy.on("noteAcknowledged", function (result) {
                _acknowledgeNote(result);
            })

            proxy.on("removeServiceOrderAssignmet", function (result) {
                _removeServiceOrderAssignment(result);
            });

            proxy.on("serviceOrderAssigned", function (result) {
                _serviceOrderAssigned(result);
            });

            
            proxy.on("completionAdded", function (result) {
                _completionAdded(result);
            });

            proxy.on("bookingUpdated", function (result) {
                _bookingUpdated(result);
            });

            proxy.on("logEntryAdded", function (result) {
                _logEntryAdded(result);
            });

            proxy.on("logEntryUpdated", function (result) {
                _logEntryUpdated(result);
            });

            proxy.on("deleteEntry", function (result) {
                _logEntryDeleted(result);
            });

            proxy.on("communityTopicCommentSaved", function (comment) {
                _commentSaved(comment);
            });

            _connection.starting(function () {
                common.notifier.notify(common.config.events.signalRStatusChange, "Connection Starting");
            });

            _connection.received(function (data) {
               // common.notifier.notify(common.config.events.signalRStatusChange, "Recieving Data");
            });
            
            _connection.connectionSlow(function () {
                common.notifier.notify(common.config.events.signalRStatusChange, "We are currently experiencing difficulties with the connection.");
            });

            _connection.reconnecting(function () {
                common.notifier.notify(common.config.events.signalRStatusChange, "Attempting to reconnect");
            });

            _connection.reconnected(function () {
                common.notifier.notify(common.config.events.signalRStatusChange, "Reconnected");
            });

            _connection.stateChanged(function (states) {
                var userData = JSON.parse(localStorage.getItem('7PointUserData'));
                if (userData && userData.bearerToken) {
                    _connection.qs = { "Bearer": userData.bearerToken };
                }
                var newState = "";
                switch (states.newState) {
                    case 0:
                        newState = "Connecting";
                        break;
                    case 1:
                        newState = "Connected";
                        break;
                    case 2:
                        newState = "Reconneting";
                        break;
                    case 4:
                        newState = "Disconnected";
                        break;

                }
                common.notifier.notify(common.config.events.signalRStatusChange, newState);
            });

            _connection.disconnected(function () {
                if (!_stopCalled) {
                    common.notifier.notify(common.config.events.signalRStatusChange, "Disconnected");
                    $timeout(function () { _startConnectionAndSubscribe(_connection, proxy) }, 5000);
                }
            });

            _startConnectionAndSubscribe(_connection, proxy);

            //_connection.start().done(function () {  proxy.invoke("subscribe").done(function () { });  });
        }

        function _startConnectionAndSubscribe(connection, proxy) {
            connection.start().done(function () {
                proxy.invoke("subscribe").done(function () {
                });
            }).fail(function () { common.config.events.signalRStatusChange, "Could Not Connect" })
            _stopCalled = false;
        }


        function _addNote(result) {
            _addItemToSubCollection(result, "Notes", "ID", "DateAddedUtc");
            _processForToast();
        }

        function _completionAdded(result) {
            _addItemToSubCollection(result, "Completions", "DateAddedUtc", "DateAddedUtc");
            _addCompletionToBookData(service.bookData, result);
            _addCompletionToBookData(service.displayedBookData, result);
            $rootScope.$apply();
        }

        function _addCompletionToBookData(bookData, result) {
            if (bookData && bookData.length > 0) {

                for (var i = 0; i < bookData.length; i++) {
                    var building = bookData[i];
                    for (var ii = 0; ii < building.Rooms.length; ii++) {
                        var room = building.Rooms[ii];
                        for (var iii = 0; iii < room.Bookings.length; iii++) {
                            var t = room.Bookings[iii];
                            if (t["BookingId"] == result.ParentId) {
                                var matched = false;
                                for (var j = 0; j < t["Completions"].length; j++) {
                                    if (t["Completions"][j]["DateAddedUtc"] == result["DateAddedUtc"]) {
                                        matched = true;
                                        break;
                                    }
                                }

                                if (!matched) {
                                    t["Completions"].push(result);
                                    t["Completions"].sort(function (a, b) {
                                        a = new Date(a["DateAddedUtc"]);
                                        b = new Date(b["DateAddedUtc"]);
                                        return a > b ? -1 : a < b ? 1 : 0
                                    });
                                }
                            }
                        }
                    }

                }
            }
        }

        function _removeServiceOrderAssignment(soId) {
            for (var i = 0; i < service.items.length; i++) {
                var b = service.items[i];
                if (b.Services) {
                    for (var j = 0; j < b.Services.length; j++) {
                        var onService = b.Services[j];
                        if (onService.ID == soId) {
                            onService.AssignedToUserId = 0;
                            onService.AssignedTo = "";
                        }
                    }
                }
            }
            _removeServiceAssignmentFromBookData(service.bookData, soId);
            _removeServiceAssignmentFromBookData(service.displayedBookData, soId);
            

            service.displayedItems = [].concat(service.items);
            $rootScope.$apply();
        }

        function _removeServiceAssignmentFromBookData(bookData, soId) {
            if (bookData && bookData.length > 0) {
                for (var i = 0; i < bookData.length; i++) {
                    var building = bookData[i];
                    for (var ii = 0; ii < building.Rooms.length; ii++) {
                        var room = building.Rooms[ii];
                        for (var iii = 0; iii < room.Bookings.length; iii++) {
                            var t = room.Bookings[iii];
                            if (t.Services) {
                                for (var j = 0; j < t.Services.length; j++) {
                                    var onService = t.Services[j];
                                    if (onService.ID == soId) {
                                        onService.AssignedToUserId = 0;
                                        onService.AssignedTo = "";
                                    }
                                }
                            }
                        }
                    }

                }
            }
        }

        function _serviceOrderAssigned(dto) {
            for (var i = 0; i < service.items.length; i++) {
                var b = service.items[i];
                if (b.Services) {
                    for (var j = 0; j < b.Services.length; j++) {
                        var onService = b.Services[j];
                        if (onService.ID == dto.ServiceOrderId) {
                            onService.AssignedToUserId = dto.AssignedToUserId;
                            onService.AssignedTo = dto.AssignedTo;
                        }
                    }
                }
            }

            _addServiceOrderAssignmentToBookData(service.bookData, dto);
            _addServiceOrderAssignmentToBookData(service.displayedBookData, dto);

            service.displayedItems = [].concat(service.items);
            $rootScope.$apply();
        }
        function _addServiceOrderAssignmentToBookData(bookData, dto) {
            if (bookData && bookData.length > 0) {
                for (var i = 0; i < bookData.length; i++) {
                    var building = bookData[i];
                    for (var ii = 0; ii < building.Rooms.length; ii++) {
                        var room = building.Rooms[ii];
                        for (var iii = 0; iii < room.Bookings.length; iii++) {
                            var t = room.Bookings[iii];
                            if (t.Services) {
                                for (var j = 0; j < t.Services.length; j++) {
                                    var onService = t.Services[j];
                                    if (onService.ID == dto.ServiceOrderId) {
                                        onService.AssignedToUserId = dto.AssignedToUserId;
                                        onService.AssignedTo = dto.AssignedTo;
                                    }
                                }
                            }
                        }
                    }

                }
            }

}

        function _commentSaved(comment) {
            if (service.topic.UId === comment.CommunityTopicUId) {

                var updated = false;
                for (var i = 0; i < service.items.length; i++) {
                    if (service.items[i].ID === comment.ID) {
                        for (var key in item) {
                            service.items[i][key] = comment[key];
                        }
                        updated = true;
                        break;
                    }
                }
                if (!updated) {
                    service.items.push(comment);
                    service.items.sort(function (a, b) {
                        a = new Date(a["DateAddedUtc"]);
                        b = new Date(b["DateAddedUtc"]);
                        return a < b ? -1 : a > b ? 1 : 0;
                    });
                }
                service.displayedItems = [].concat(service.items);

                $rootScope.$apply();
            }
        }
       
        function _addAlert(item) {
            common.notifier.notify(config.events.refreshCounts);
            var displayFrom = moment.utc(item.DisplayFromUtc).toDate();
            var displayTo = moment.utc(item.DisplayToUtc).toDate();
            var utcNow = moment.utc().toDate();

            var userDepartments = common.userService.departmentIds();
            
            var dId = item.DepartmentId + "";
            if (displayFrom < utcNow && utcNow < displayTo && (userDepartments.indexOf(dId) >= 0 || dId == 0) ){
              
                var updated = false;
                for (var i = 0; i < service.items.length; i++) {
                    if (service.items[i].ID == item.ID) {
                        for (var key in item) {
                            service.items[i][key] = item[key];
                        }
                        updated = true;
                        break;
                    }
                }
                if (!updated) {
                    service.items.push(item);
                }
                service.displayedItems = [].concat(service.items);
                $rootScope.$apply();
            }
        }

        function _logEntryAdded(item) {
            var onDateDisplay = moment(common.getMainState("mainDate")).format("YYYY-MM-DD");
            var itemDateDisplay = moment(item.DisplayOn).format("YYYY-MM-DD");

            if (onDateDisplay == itemDateDisplay) {
                
                var updated = false;
                for (var i = 0; i < service.items.length; i++) {
                    if (service.items[i].ID == item.ID) {
                        service.items[i] == item;
                        updated = true;
                        break;
                    }
                }
                if (!updated) {
                    service.items.push(item);
                }

                service.displayedItems = [].concat(service.items);
                $rootScope.$apply();
            }
            
        }


        function _addTask(result) {
            var userDepartments = common.userService.departmentIds();
            
            common.notifier.notify(config.events.refreshCounts);
            var onDateDisplay = moment(common.getMainState("mainDate")).format("YYYY-MM-DD");
            var itemDateDisplay = moment(result.TaskDisplayOn).format("YYYY-MM-DD");
            var dIds = result.DepartmentIds;
            
            for (var j = 0; j < dIds.length; j++) {
                var updated = false;
                var dId = dIds[j] + "";
                //this will add the task to display at the top
                if (onDateDisplay == itemDateDisplay && userDepartments.indexOf(dId) >= 0) {
                    for (var i = 0; i < service.items.length; i++) {
                        if (service.items[i].TaskId == result.TaskId) {
                            service.items[i] = result;
                            updated = true;
                            break;
                        }
                    }
                    if (!updated) {
                        service.items.push(result);
                    }
                }
            }
            service.displayedItems = [].concat(service.items);

            if (result.LinkedBookingId > 0) {
                for (var i = 0; i < service.items.length; i++) {
                    if (service.items[i].BookingId == result.LinkedBookingId) {
                        if (!service.items[i].LinkedTasks) {
                            service.items[i].LinkedTasks = [];
                        }
                        service.items[i].LinkedTasks.push(result);
                        break;
                    }
                }
            }

            $rootScope.$apply();
        }

        function _bookingUpdated(result) {
            for (var i = 0; i < service.items.length; i++) {
                var b = service.items[i];
                if (b.BookingId == result.BookingId) {
                    b.BuildingLocalEventEnd = result.BuildingLocalEventEnd;
                    b.BuildingLocalEventEndDisplay = result.BuildingLocalEventEndDisplay;
                    b.BuildingLocalReseveredEnd = result.BuildingLocalReseveredEnd;
                    b.BuildingLocalReseveredEndDisplay = result.BuildingLocalReseveredEndDisplay;
                    service.items[i] = b;
                }
            }

            _updateBookingInBookData(service.bookData, result);
            _updateBookingInBookData(service.displayedBookData, result);
         
            service.displayedItems = [].concat(service.items);
            $rootScope.$apply();
        }

        function _updateBookingInBookData(bookData, result) {
            if (bookData && bookData.length > 0) {
                for (var i = 0; i < bookData.length; i++) {
                    var building = bookData[i];
                    for (var ii = 0; ii < building.Rooms.length; ii++) {
                        var room = building.Rooms[ii];
                        for (var iii = 0; iii < room.Bookings.length; iii++) {
                            var t = room.Bookings[iii];
                            if (t.BookingId == result.BookingId) {
                                t.BuildingLocalEventEnd = result.BuildingLocalEventEnd;
                                t.BuildingLocalEventEndDisplay = result.BuildingLocalEventEndDisplay;
                                t.BuildingLocalReseveredEnd = result.BuildingLocalReseveredEnd;
                                t.BuildingLocalReseveredEndDisplay = result.BuildingLocalReseveredEndDisplay;

                                room.Bookings[iii] = t;
                                break;
                            }
                        }
                    }

                }
            }
        }

        function _availableAtUpdated(result) {
            for (var i = 0; i < service.items.length; i++) {
                var b = service.items[i];
                if (b.BookingId == result.BookingId) {

                    var buildingLocalTime = moment(b.BuildingLocalEventStart);
                    var raat = moment(b.BuildingLocalEventStart);
                    var timeParts = result.AvailableAt.split(':');
                    raat = raat.hour(timeParts[0]);
                    raat = raat.minute(timeParts[1]);

                    b.RoomAvailableAt = raat.format("HH:mm");

                    if (raat.isAfter(buildingLocalTime)) {
                        b.RoomAvailableAtSort = raat.subtract(1, 'days').format("YYYY-MM-DDTHH:mm");
                    }
                    else {
                        b.RoomAvailableAtSort = raat.format("YYYY-MM-DDTHH:mm");
                    }

                    break;
                }
            }
            service.displayedItems = [].concat(service.items);
            $rootScope.$apply();
        }

        function _deleteNote(id) {
            _deleteNoteFromItemWithNotes(id, service.items);
            for (var j = 0; j < service.items.length; j++) {
                _deleteNoteFromItemWithNotes(id, service.items[j].LinkedTasks);
            }
            $rootScope.$apply();
        }

        function _deleteNoteFromItemWithNotes(id, colT) {
            if (colT && colT.length > 0) {
                for (var i = 0; i < colT.length; i++) {
                    var matched = false;
                    $.each(colT[i].Notes, function (index, result) {
                        if (result) {
                            if (result["ID"] == id) {
                                colT[i].Notes.splice(index, 1);
                                matched = true;
                                return false;
                            }
                        }
                    });
                    if (matched) {
                        break;
                    }
                }
            }
        }


        function _logEntryUpdated(entry) {
            for (var i = 0; i < service.items.length; i++) {
                var t = service.items[i];
                if (t.ID == entry.ID) {
                    t.Entry = entry.Entry;
                    break;
                }
            }
            $rootScope.$apply();
        }

        function _logEntryDeleted(id) {
            $.each(service.items, function (index, result) {
                if (result) {
                    if (result["ID"] == id) {
                        service.items.splice(index, 1);
                    }
                }
            });
            $rootScope.$apply();
        }
        

        function _updateNote(note) {
            var idProp = note.BookingId == 0 ? "TaskId" : "BookingId";
            for (var i = 0; i < service.items.length; i++) {
                var t = service.items[i];
                _updateNoteInItemWithNotes(idProp, t, note);
                if (t.LinkedTasks && t.LinkedTasks.length > 0) {
                    for (var j = 0; j < t.LinkedTasks.length; j++) {
                        var lt = t.LinkedTasks[j];
                        _updateNoteInItemWithNotes(idProp, lt, note);
                    }
                }
            }
            $rootScope.$apply();
        }

        function _acknowledgeNote(note) {
            for (var i = 0; i < service.items.length; i++) {
                var t = service.items[i];

                if (t.BookingId == note.ParentId) {
                    t.RequiresAcknowledgement = false;
                    for (var j = 0; j < t.Notes.length; j++) {
                        if (t.Notes[j].ID == note.ID) {
                            t.Notes[j].Notes = note.Notes;
                            t.Notes[j].AcknowledgedBy = note.AcknowledgedBy;
                            t.Notes[j].AcknowledgedByInitials = note.AcknowledgedByInitials;
                            t.Notes[j].AcknowledgedAtUtc = note.AcknowledgedAtUtc;
                            t.Notes[j].UserCanAcknowledge = note.UserCanAcknowledge;
                            break;
                        }
                    }
                    break;
                }
            }
            _processForToast();

            $rootScope.$apply();
        }

        function _processForToast() {
            var numberOfItemsRequiringAttention = 0;
            for (var i = 0; i < service.items.length; i++) {
                var onItem = service.items[i];
                if (onItem.RequiresAcknowledgement) {
                    numberOfItemsRequiringAttention++;
                }
            }
            common.logger.clearToast();
            if (numberOfItemsRequiringAttention > 0) {
                common.logger.forceAcknowledge("There are " + numberOfItemsRequiringAttention + " items that need your attention", "Urgent Action Required");
            }
        }


        function _updateNoteInItemWithNotes(idProp, t, note) {
            if (t[idProp] == note[idProp]) {
                for (var j = 0; j < t.Notes.length; j++) {
                    if (t.Notes[j].ID == note.ID) {
                        t.Notes[j].Notes = note.Notes;
                        break;
                    }
                }
            }
        }


        function _addItemToSubCollection(dto, subCollectionName, subCollectionCompareProperty, subCollectionSortProperty) {
            var idProp = "BookingId";
            if (dto.ParentType == 2) {
                idProp = "TaskId";
            }
            else if (dto.ParentType == 9) {
                idProp = "DailyLogEntryId";
            }
            else if (dto.ParentType == 10) {
                idProp = "ID";
            }

            if (dto.ParentType == 10) {  //new service order completion
                for (var i = 0; i < service.items.length; i++) {
                    var rootItem = service.items[i];
                    if (rootItem.Services != null) {
                        for (var j = 0; j < rootItem.Services.length; j++) {
                            var onService = rootItem.Services[j];
                            if (onService.ID == dto.ParentId) {
                                onService.Completions.push(dto);
                                onService.Completions.sort(function (a, b) {
                                    a = new Date(a["DateAddedUtc"]);
                                    b = new Date(b["DateAddedUtc"]);
                                    return a > b ? -1 : a < b ? 1 : 0
                                });
                            }
                        }
                    }
                }
            }
            else {
                for (var i = 0; i < service.items.length; i++) {
                    var t = service.items[i];
                    if (t[idProp] == dto.ParentId) {
                        if (subCollectionName === "Notes") {
                            if (dto.DepartmentId !== null && !dto.AcknowledgedAtUtc) {
                                t.RequiresAcknowledgement = true;
                            }
                        }
                        var matched = false;
                        for (var j = 0; j < t[subCollectionName].length; j++) {
                            if (t[subCollectionName][j][subCollectionCompareProperty] == dto[subCollectionCompareProperty]) {
                                matched = true;
                                break;
                            }
                        }
                        if (!matched) {
                            t[subCollectionName].push(dto);
                            t[subCollectionName].sort(function (a, b) {
                                a = new Date(a[subCollectionSortProperty]);
                                b = new Date(b[subCollectionSortProperty]);
                                return a > b ? -1 : a < b ? 1 : 0
                            });
                        }

                        break;
                    }
                }
                if (dto.ParentType == 2) {
                    for (var iii = 0; iii < service.items.length; iii++) {
                        var onItem = service.items[iii];
                        if (onItem.LinkedTasks && onItem.LinkedTasks.length > 0) {
                            for (var ii = 0; ii < onItem.LinkedTasks.length; ii++) {
                                var onLinkedTask = onItem.LinkedTasks[ii];
                                if (onLinkedTask[idProp] == dto.ParentId) {
                                    var linkedMatched = false;
                                    for (var jj = 0; jj < onLinkedTask[subCollectionName].length; jj++) {
                                        if (onLinkedTask[subCollectionName][jj][subCollectionCompareProperty] == dto[subCollectionCompareProperty]) {
                                            linkedMatched = true;
                                            break;
                                        }
                                    }
                                    if (!linkedMatched) {
                                        onLinkedTask[subCollectionName].push(dto);
                                        onLinkedTask[subCollectionName].sort(function (a, b) {
                                            a = new Date(a[subCollectionSortProperty]);
                                            b = new Date(b[subCollectionSortProperty]);
                                            return a > b ? -1 : a < b ? 1 : 0
                                        });
                                    }

                                    break;
                                }
                            }
                        }
                    }
                }
            }
            
            $rootScope.$apply();
        }

        
    }
}());
